<template>
  <div>
    <dx-data-grid ref='refDokubGrid'
        :data-source='doKubInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        height='400' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="생산기준일"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="excelFileName"
        />
        <DxFilterRow
          :visible="false"
          apply-filter="auto"
        />
        <DxColumn
          caption="생산일"
          data-field="생산기준일"
          dataType='date'
          sort-order='asc'
          format='yyyy-MM-dd'>
        </DxColumn>
        <DxColumn
          caption="도급업체"
          data-field="도급업체"
        />
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          width="80"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
       <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          width='80'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
          width='80'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="라인명"
          data-field="라인코드"
          :visible='true'
        >
          <DxLookup
            :data-source="productionLineLookup"
            display-expr="라인명"
            value-expr="라인코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="생산수량"
          data-field="생산수량"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="도급단가"
          data-field="도급단가"
          :visible='true'
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="월도급비용"
          data-field="도급비용"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="생산기준일"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="생산수량"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="도급비용"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'

export default {
  name: 'DoKubDetailSubGrid',
  data: function () {
    return {
      doKubInfoList: null,
      gridHeightTree: null,
      itemTypeLookup: null,
      processingTypeLookup: null,
      excelFileName: null
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    baseDate: {
      type: Object,
      default: null
    },
    productionLineLookup: {
      type: Array,
      default: null
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxLookup,
    DxExport,
    DxSummary,
    DxTotalItem,
    DxSorting,
    DxSearchPanel,
    DxFilterRow
  },
  created () {
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
  },
  mounted () {
    console.log(this.item)
    this.refreshDokubDetail(this.item.key, this.item.data.도급업체)
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcCostSum (row) {
      return (row.재료비소계 + row.도급비용)
    },
    onToolbarPreparing (e) {
    },
    refreshDokubDetail (goodsNo, 거래처명) {
      this.excelFileName = `${goodsNo}_${this.baseDate.fromDate.substring(0, 8)}월_도급생산`
      this.$emit('refresh-detail-completed')
      this.baseDate.품번 = goodsNo
      this.baseDate.거래처명 = 거래처명

      this.$_sp.runNoEncodeFindProc('spFindAllDoKupDetalBillByGoodsNoGbyDate', this.baseDate)
        .then((data) => {
          this.doKubInfoList = this.$_sp.MakeModel(data)
          console.log(this.doKubInfoList)
        })
    }
  }
}
</script>

<style lang="scss">
.dx-master-detail-cell {
  padding-top: 8px!important;
}
</style>
